<template>
  <div
    :class="{
      'item--md': isMD,
      'item--active': isActive,
      customForResult: isCustomForResult
    }"
    class="item"
  >
    {{ getValue }}
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: Number
    },
    numberMix: {
      type: Boolean,
      default: false
    },

    isActive: {
      type: Boolean,
      default: true
    },
    isMD: {
      type: Boolean,
      default: false
    },
    isCustomForResult: {
      type: Boolean,
      default: false
    },
    defaultNullValue: {
      type: String,
      default: ""
    }
  },
  computed: {
    getValue() {
      if (this.numberMix) return this.mixNumber(this.number);
      // return isNaN(this.number) ? '*' : this.number || this.defaultNullValue;
      return !isNaN(this.number) ? this.number : this.defaultNullValue || "*";
    }
  }
};
</script>

<style lang="scss" scoped>
%box-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.item {
  @extend %box-center;
  //   display: inline-block;
  flex-shrink: 0;
  border-radius: 999px;
  width: 30px;
  height: 30px;
  color: $colorNumberText;
  background-color: $colorNumber;
  font-weight: $fontWeightNumber;
  font-size: $fontSizeNumber;

  border: solid 1px #dbdbdb;

  &--active {
    background-color: #ffe9a0 !important;
    color: $colorNumberText !important;
    border: none;
  }
  &--md {
    width: 40px;
    height: 40px;
    font-size: $fontSizeNumberMd;
  }

  &.customForResult {
    // width: 30px;
    // height: 30px;
    font-size: 16px;
    color: $colorNumberResultText;
    // border: solid 1px $colorNumberResult;
    border: none;
    // background-image: linear-gradient(138deg, #fff0ba, #ffbd0a);
    background-color: $colorNumberResult !important;

    @media screen and (min-width: map-get($grid-breakpoints, "lg")) {
      width: 40px;
      height: 40px;
      font-size: $fontSizeNumberMd;
    }
  }

  &.specialNumber {
    background-color: #ffd764 !important;
    background-image: none !important;
    color: #333333 !important;
    border: none !important;
  }

  @media screen and (min-width: map-get($grid-breakpoints, "md")) {
    width: 36px;
    height: 36px;
    font-size: $fontSizeNumberMd;
  }

  @media screen and (min-width: map-get($grid-breakpoints, "lg")) {
    width: 40px;
    height: 40px;
    font-size: $fontSizeNumberMd;
  }
}
</style>
